import { Box, Card, Divider } from '@mui/material';
import { FC } from 'react';
import { MainCardContent } from '../MainCard/MainCard';
import { useMainCardStyles } from '../MainCard/useMainCardStyles';
import { IconType } from '../../enums/IconType';

export type Props = {
  main: string;
  vehicle: string;
  from: string;
  to: string;
  tripIsEu?: boolean;
};

export const RouteCard: FC<Props> = ({ children, main, vehicle, from, to, tripIsEu }) => {
  const classes = useMainCardStyles();
  return (
    <Card sx={classes.root}>
      <MainCardContent
        primary1={main}
        primary2={vehicle}
        secondary1={from}
        secondary2={to}
        icon={IconType.Bus}
        tripIsEu={tripIsEu}
      />
      <Divider />
      <Box p={1}>{children}</Box>
    </Card>
  );
};
